/**
 * @author Kelnik
 *
 * AdditionFilters - дополнение к фильтру
 */

import Observer from 'common/scripts/mediator';
import tmplItem from './item.twig';
import Utils from 'common/scripts/utils';

const observer = new Observer();

class AdditionFilters {
    constructor(options) {
        this.options = options;
        this.containerSelector = '.j-addition-filters';
        this.container = options.wrapper ? options.wrapper.querySelector(this.containerSelector) : null;

        this.itemSelector = '.j-addition-filters-item';
        this.removeSelector = '.j-addition-filters-remove';

        this.init();
    }

    init() {
        if (!this.container) {
            return;
        }

        this._initElements();
        this._bindEvents();
    }

    _initElements() {
        this.__initElementsAfterAdd();
    }

    __initElementsAfterAdd() {
        this.removes = Array.from(this.container.querySelectorAll(this.removeSelector));
    }

    _bindEvents() {
        this._bindEventsAfterAdd();

        observer.subscribe('filter-popup:term', (data) => {
            this._addItem(data);
        });

        observer.subscribe('filter-popup:installment', (data) => {
            this._addItem(data);
        });

        observer.subscribe('filter-popup:floor', (data) => {
            this._addItem(data);
        });

        observer.subscribe('filter-popup:pay', (data) => {
            this._addItem(data);
        });
    }

    _bindEventsAfterAdd() {
        this.removes.forEach((remove) => {
            if (remove.hasAttribute('init')) {
                return;
            }

            remove.setAttribute('init', '');

            remove.addEventListener('click', () => {
                const name = remove.dataset.name;

                this._removeItem(remove);

                observer.publish('addition-filters:remove', name);
            });
        });
    }

    _addItem(data) {
        const items = Array.from(this.container.querySelectorAll(this.itemSelector));
        const cloneItem = items.find((item) => {
            return item.dataset.name === data.name;
        });

        if (cloneItem) {
            Utils.removeElement(cloneItem);
        }

        if (!data.value) {
            return;
        }

        Utils.insetContent(this.container, tmplItem({filter: data}));

        this.__initElementsAfterAdd();
        this._bindEventsAfterAdd();
    }

    _removeItem(element) {
        const parent = element.closest(this.itemSelector);

        if (!parent) {
            return;
        }

        Utils.removeElement(parent);
    }
}

export default AdditionFilters;
